<template>
  <div class="compressed-content">
    <h3>Has it been easy for you to follow the recommend changes?</h3>
    <v-form-group class="card-selector page-buttons">
      <b-form-radio v-model="survey.feedback.followChangesCMR" name="followChangesCMR"
                    :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.feedback.followChangesCMR" name="followChangesCMR"
                    :value="false">No</b-form-radio>
      <b-form-radio v-model="survey.feedback.followChangesCMR" name="followChangesCMR"
                    :value="null">Not Applicable</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    computed: {
      ...mapState(["survey"]),

      followChangesCMR() { return this.survey.feedback.followChangesCMR; }
    }
  };
</script>